import { pickThemeColor } from '@/theme';
import styled from 'styled-components';

export const StyledFooter = styled.footer`
  padding: 2rem;
  border-top: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  background-color: ${pickThemeColor('BG_SECONDARY')};
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: center;
  margin-top: auto;
`;

export const StyledContainer = styled.div`
  padding: 0 1.75rem 1.75rem 1.75rem;
`;
